import { writable } from "svelte/store";

export const authToken = writable(null);
export const currentLang = writable("de");
